module.exports = __webpack_public_path__ + "static/img/Logo_AZ@2x.e22e246.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/Logo_AZ@2x.png
// module id = OCJs
// module chunks = 1